module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPBAMAAAAmOuNHAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBQTFRFAAAAmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZsvyjQQAAABB0Uk5TAERmVRHu/5mIzN2quyIzd49/UpcAAABjSURBVHicY2BgEDJhAAHTtLQSIMWRaSie5cDAIFYAxBsYGE6BxHIZGDKANF8SA0M+kOYFEulQ/lGgWnag/LMtDAxmQD1MWZ910pYAJSXTUv+DDGK4+IDh2xKwFQz8WRCa4QcAd3kV262IcEcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_search.png
// module id = 3xrr
// module chunks = 0